export const Config = {
  prod: {
    apiKey: "AIzaSyBsTVg1eR-4h10puNjSSweLs9PI1QRLC40",
    authDomain: "kaigi-100.firebaseapp.com",
    databaseURL:
      "https://kaigi-100-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "kaigi-100",
    storageBucket: "kaigi-100.appspot.com",
    messagingSenderId: "1038453618131",
    appId: "1:1038453618131:web:9758cec21286b9ca5f2b26",
  },
  dev: {
    apiKey: "AIzaSyCPNqLetfZrcevhU7lCBxA8fbJbvcM5ndA",
    authDomain: "kaigi-100-dev.firebaseapp.com",
    databaseURL:
      "https://kaigi-100-dev-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "kaigi-100-dev",
    storageBucket: "kaigi-100-dev.appspot.com",
    messagingSenderId: "215917348350",
    appId: "1:215917348350:web:f9c7ffd83a300d925a6caf",
  },
  local: {
    apiKey: "AIzaSyBT8N2EsMBmjA6NCczp9EKuaKa4Gfqo_ew",
    authDomain: "kaigi-100-local.firebaseapp.com",
    databaseURL:
      "https://kaigi-100-local-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "kaigi-100-local",
    storageBucket: "kaigi-100-local.appspot.com",
    messagingSenderId: "124311778181",
    appId: "1:124311778181:web:1fa0632b83205d83a58aec",
  },
};
